function addElementAfter(targetDOM, element){
	let node;
	if(element.includes('.')){
		node = document.createElement('div')
		node.classList = element.replace('.', '')
	}
	const targetParentDOM = targetDOM.parentNode;
	targetParentDOM.appendChild(node)
}

function manageFileInput(targetDOM, element){
	targetDOM.addEventListener('change', event => {
		let fileName = '';
		if( targetDOM.files && targetDOM.files.length > 1 )
			fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
		else{
			fileName = targetDOM.value.split( '\'' ).pop()
		}

		targetDOM.parentNode.parentNode.parentNode.querySelector('.js-file-text').innerHTML = fileName
	})



	console.log(targetDOM)
}

export {
	manageFileInput,
	addElementAfter
}